// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.siwFinishInfoBox {
    background-color: #F4F4F5;
    border-radius: 10px;
    padding: 24px;
    margin-bottom: 24px;
}

.siwFinishIcon {
    width: 32px;
    height: 32px;
    margin-right: 20px;
}

.siwFinishInfoBoxHeader {
    font-size: 18px;
    color: var(--integration-text-color);
    margin-bottom: 10px;
}

.siwFinishInfoBoxText {
    font-size: 14px;
    color: var(--integration-light-text-color);
}

.siwFinishButton {
    background: #FFFFFF;
    border: 1px solid var(--integration-border-color);
    border-radius: 6px;
    align-self: flex-start;
    padding: 9px 12px;
    font-size: 15px;
    color: var(--integration-text-color);
}

.siwFinishButtonIcon {
    width: 16px;
    height: 16px;
    align-self: center;
    margin-right: 8px;
}

.siwFinishTableLeftCol {
    width: 220px;
}

.siwFinishTableHeaderBox {
    margin-left: 52px;
    margin-bottom: 10px;
}

.siwFinishTableRow {
    margin-left: 52px;
    height: 76px;
    border-top: 1px solid var(--integration-border-color);
}

.siwFinishTableName {
    font-size: 14px;
    color: var(--integration-text-color);
    align-self: center;
    font-weight: 600;
}

.siwFinishFieldName {
    font-size: 14px;
    color: #000000;
    background-color: #FFFFFF;
    border-radius: 4px;
    padding: 4px 8px;
    margin-right: 8px;
    font-weight: 600;
}

.siwFinishTargetBox {
    margin-left: 52px;
}

.siwFinishStartButton {
    margin-bottom: 24px;
}

.siwFinishSuccessRow {
    background-color: var(--integration-background);
    color: var(--integration-text-color);
    border-radius: 7px;
    padding: 16px;
    margin-bottom: 24px;
}

.siwFinishRowText {
    align-self: center;
    margin: 0px 16px;
    font-weight: 600;
}

.siwFinishRowIcon {
    align-self: center;
    width: 20px;
    height: 20px;
}

.siwFinishSuccessRow .siwFinishBackgroundIcon {
    background-color: var(--integration-text-color);
    fill: var(--integration-background);
    border-radius: 50%;
}

.siwFinishSuccessBox {
    background-color: #F9FAFB;
    border-radius: 10px;
    padding: 20px 24px;
}

.siwFinishSuccessBoxHeader {
    font-size: 20px;
    color: var(--integration-text-color);
}

.siwFinishSuccessBoxInfo {
    font-size: 15px;
    color: var(--integration-light-text-color);
    margin: 20px 0px;
}

.siwFinishErrorRow {
    color: #991B1B;
    background-color: #FEF2F2;
    border-radius: 7px;
    padding: 16px;
    margin-bottom: 24px;
}

    .siwFinishErrorRow .siwFinishBackgroundIcon {
        border: 2px solid #991B1B;
        border-radius: 50%;
        fill: #991B1B;
    }

.siwFinishErrorInfo {
    margin-left: 16px;
    margin-top: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/integration/smartintegration/smartintegrationwizard/siw.finish.page.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,iDAAiD;IACjD,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;IAC/C,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,+CAA+C;IAC/C,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;IAEI;QACI,yBAAyB;QACzB,kBAAkB;QAClB,aAAa;IACjB;;AAEJ;IACI,iBAAiB;IACjB,gBAAgB;AACpB","sourcesContent":[".siwFinishInfoBox {\n    background-color: #F4F4F5;\n    border-radius: 10px;\n    padding: 24px;\n    margin-bottom: 24px;\n}\n\n.siwFinishIcon {\n    width: 32px;\n    height: 32px;\n    margin-right: 20px;\n}\n\n.siwFinishInfoBoxHeader {\n    font-size: 18px;\n    color: var(--integration-text-color);\n    margin-bottom: 10px;\n}\n\n.siwFinishInfoBoxText {\n    font-size: 14px;\n    color: var(--integration-light-text-color);\n}\n\n.siwFinishButton {\n    background: #FFFFFF;\n    border: 1px solid var(--integration-border-color);\n    border-radius: 6px;\n    align-self: flex-start;\n    padding: 9px 12px;\n    font-size: 15px;\n    color: var(--integration-text-color);\n}\n\n.siwFinishButtonIcon {\n    width: 16px;\n    height: 16px;\n    align-self: center;\n    margin-right: 8px;\n}\n\n.siwFinishTableLeftCol {\n    width: 220px;\n}\n\n.siwFinishTableHeaderBox {\n    margin-left: 52px;\n    margin-bottom: 10px;\n}\n\n.siwFinishTableRow {\n    margin-left: 52px;\n    height: 76px;\n    border-top: 1px solid var(--integration-border-color);\n}\n\n.siwFinishTableName {\n    font-size: 14px;\n    color: var(--integration-text-color);\n    align-self: center;\n    font-weight: 600;\n}\n\n.siwFinishFieldName {\n    font-size: 14px;\n    color: #000000;\n    background-color: #FFFFFF;\n    border-radius: 4px;\n    padding: 4px 8px;\n    margin-right: 8px;\n    font-weight: 600;\n}\n\n.siwFinishTargetBox {\n    margin-left: 52px;\n}\n\n.siwFinishStartButton {\n    margin-bottom: 24px;\n}\n\n.siwFinishSuccessRow {\n    background-color: var(--integration-background);\n    color: var(--integration-text-color);\n    border-radius: 7px;\n    padding: 16px;\n    margin-bottom: 24px;\n}\n\n.siwFinishRowText {\n    align-self: center;\n    margin: 0px 16px;\n    font-weight: 600;\n}\n\n.siwFinishRowIcon {\n    align-self: center;\n    width: 20px;\n    height: 20px;\n}\n\n.siwFinishSuccessRow .siwFinishBackgroundIcon {\n    background-color: var(--integration-text-color);\n    fill: var(--integration-background);\n    border-radius: 50%;\n}\n\n.siwFinishSuccessBox {\n    background-color: #F9FAFB;\n    border-radius: 10px;\n    padding: 20px 24px;\n}\n\n.siwFinishSuccessBoxHeader {\n    font-size: 20px;\n    color: var(--integration-text-color);\n}\n\n.siwFinishSuccessBoxInfo {\n    font-size: 15px;\n    color: var(--integration-light-text-color);\n    margin: 20px 0px;\n}\n\n.siwFinishErrorRow {\n    color: #991B1B;\n    background-color: #FEF2F2;\n    border-radius: 7px;\n    padding: 16px;\n    margin-bottom: 24px;\n}\n\n    .siwFinishErrorRow .siwFinishBackgroundIcon {\n        border: 2px solid #991B1B;\n        border-radius: 50%;\n        fill: #991B1B;\n    }\n\n.siwFinishErrorInfo {\n    margin-left: 16px;\n    margin-top: 12px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
